import { fetchApi } from '@/config/axiosSetting';
import { GetCulpritReceivedCorrectiveParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritReceivedCorrectiveImages/getCulpritReceivedCorrectiveImages.type';
import { GetRecievedCorrectiveResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getRecievedCorrectiveImages/getRecievedCorrectiveImages.type';

export const getCulpritReceivedCorrectiveImagesFunction = (
  params: GetCulpritReceivedCorrectiveParamsType,
): Promise<GetRecievedCorrectiveResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/corrective/receive/list/`,
  );
};
